import gql from "graphql-tag";

export const GET_POINT_QUERY = gql`
  fragment paragraph on Paragraph {
    ... on ParagraphCopy {
      fieldCopy {
        value
      }
    }
    ... on ParagraphAudio {
      fieldAudioUrl
    }
    ... on ParagraphImage {
      fieldImage {
        alt
        url
      }
    }
    ... on ParagraphVideo {
      fieldVideoUrl
    }
  }

  fragment hero on Paragraph {
    ... on ParagraphHeroImage {
      fieldHeroImage {
        alt
        url
      }
    }
    ... on ParagraphHeroVideo {
      fieldHeroVideoUrl
    }
  }

  fragment basefields on Node {
    uuid
    entityId
    title
  }

  query GET_POINT_BY_ID($id: String!) {
    nodeById(id: $id) {
      ... on NodeHeritageSite {
        ...basefields
        fieldContent {
          entity {
            ...paragraph
          }
        }
        fieldHero {
          entity {
            ...hero
          }
        }
        fieldSiteName
        fieldLocation
        fieldSiteLink {
          uri
          title
        }
      }
      ... on NodeEvent {
        ...basefields
        fieldContent {
          entity {
            ...paragraph
          }
        }
        fieldEventLocation
        fieldEndDate {
          value
          date
        }
        fieldStartDate {
          value
          date
        }
        fieldHero {
          entity {
            ...hero
          }
        }
        fieldSiteLink {
          uri
          title
        }
      }
      ... on NodeSayings {
        ...basefields
        entityId
        title
        fieldSayingEmail
        fieldSayingRegion
        fieldSayingContext
        fieldSayingMeaning
        fieldSayingMediaUrl
        fieldMapCoordinateX
        fieldMapCoordinateY
        fieldSayingSourceUrl
        fieldSayingAssociation {
          targetId
        }
        fieldSayingSubmittedBy
      }
    }
  }
`;
